import React, { Dispatch } from 'react';
import { GIButton, Modal } from 'app-components';
import { FormattedMessage } from 'react-intl/dist';
import styled from 'styled-components';
import { ModalContextType } from '../../../../contexts/modalContext';
import { ConditionalRendering, fetchApplicationsDetails, environmentSelector, useAppSelector, useAppDispatch } from '../../utils';


const StyledModalBoday = styled.div`
    @media (max-width: 768px) {
        .gi-modal__body {
            max-height: 0%;
            padding-bottom: 0px;
        }
    }
`;

const StyledField = styled.div`
    padding: 10px 0px;
`;

const StyledControls = styled.div`
    align-items: right;
`;

interface IModalProps extends ModalContextType {
    headerId: string;
    bodyContentId: string;
    bodyMsgId?: string;
    bodyMsgId2?: string;
    buttonId: string;
    coverageYear?: string;
}



const NotifyModal = ({ closeModal, headerId, bodyContentId, bodyMsgId, bodyMsgId2, buttonId, coverageYear }: IModalProps) => {
    const environment = useAppSelector(environmentSelector);
    const dispatch: Dispatch<any> = useAppDispatch();
    function onClose() {
        closeModal('notifyModal');
        if(coverageYear){
            dispatch(fetchApplicationsDetails(coverageYear, environment, () => { false }));
        }
    }

    return (
        <Modal id="override_sep_qep_denial_modal">
            <Modal.Header id="override_sep_qep_denial_modal_title" titleId={headerId} onHide={onClose} />
            <StyledModalBoday>
                <Modal.Body>
                    <StyledField>
                        <h3>
                            <FormattedMessage id={bodyContentId} />
                        </h3>
                    </StyledField>
                    <ConditionalRendering isTrue={!!bodyMsgId}>
                        <StyledField>
                            <FormattedMessage id={bodyMsgId} />
                        </StyledField>
                    </ConditionalRendering>
                    <ConditionalRendering isTrue={!!bodyMsgId2}>
                        <StyledField>
                            <FormattedMessage id={bodyMsgId2} />
                        </StyledField>
                    </ConditionalRendering>
                </Modal.Body>
            </StyledModalBoday>
            <Modal.Controls>
                <StyledControls>
                    <GIButton id="button" onClickHandler={onClose} variant="primary" labelId={buttonId} />
                </StyledControls>
            </Modal.Controls>
        </Modal>
    );
};

export default NotifyModal;
